// Cables activos de cada instalación, para elegir en la inspección diaria cuál
// cable tiene la alerta o falla de "Estado del cable" o "Punto de anclaje".
//
// Mismo esquema que lib/arbolesCache: se leen de la base al abrir el asistente
// con señal (rpc cables_lineas_para_inspeccion) y se guardan en localStorage
// con la hora de carga, porque arriba en las plataformas a veces no hay señal.
// La clave NO empieza con `cables-pin:` (salir del PIN la borraría y la lista
// no es de la persona, es de la instalación). Ningún fallo de localStorage lanza.
import { idsArboles } from './arbolesCache';

export const CLAVE_LINEAS = 'cables-lineas:v1';

// Ítems del checklist en los que, con Alerta o Falla, se elige el cable.
export const ITEMS_CON_LINEA = ['punto_anclaje', 'estado_cable'];

export const claveLineas = (instalacion) => `${CLAVE_LINEAS}:${instalacion || 'canopy'}`;

const texto = (v) => (typeof v === 'string' ? v.trim() : '');
const orden = new Intl.Collator('es', { numeric: true, sensitivity: 'base' });

// Filas de la rpc (o del caché) -> [{ id, codigo, nombre, plataforma_desde, plataforma_hasta }] por código.
export const normalizarLineas = (filas) => {
  if (!Array.isArray(filas)) return [];
  return filas
    .filter((f) => f && typeof f === 'object' && texto(f.id) && texto(f.codigo))
    .map((f) => ({
      id: texto(f.id),
      codigo: texto(f.codigo),
      nombre: texto(f.nombre),
      plataforma_desde: texto(f.plataforma_desde),
      plataforma_hasta: texto(f.plataforma_hasta),
    }))
    .sort((a, b) => orden.compare(a.codigo, b.codigo));
};

// Lista de ids elegidos: solo textos, sin vacíos ni repetidos.
export const idsLineas = idsArboles;

// Texto secundario del chip: el tramo, o el nombre si no hay plataformas.
export const tramoCorto = (l) => {
  if (l?.plataforma_desde || l?.plataforma_hasta) return `${l.plataforma_desde || '?'} → ${l.plataforma_hasta || '?'}`;
  return l?.nombre || '';
};

export const guardarLineasCache = (instalacion, lineas, at = Date.now()) => {
  try {
    localStorage.setItem(claveLineas(instalacion), JSON.stringify({ at, lineas: normalizarLineas(lineas) }));
  } catch (e) {
    /* sin almacenamiento o sin cuota: se usa la lista en memoria */
  }
};

// { at, lineas } o null si no hay nada guardado (o no se puede leer).
export const leerLineasCache = (instalacion) => {
  try {
    const t = localStorage.getItem(claveLineas(instalacion));
    if (!t) return null;
    const c = JSON.parse(t);
    if (!c || !Array.isArray(c.lineas)) return null;
    return { at: Number.isFinite(c.at) ? c.at : null, lineas: normalizarLineas(c.lineas) };
  } catch (e) {
    return null;
  }
};
